import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';

@Component({
  selector: 'app-shop-categorizado',
  templateUrl: './shop-categorizado.component.html',
  styleUrls: ['./shop-categorizado.component.css']
})
export class ShopCategorizadoComponent implements OnInit {
  hideCL: boolean = false;
  listaProdutos: any[] = [];
  listaProdutosTermo: any[] = [];
  cidadeAtual: any = '';
  categoriaAtual: any = '';
  nomeCategoria: any = '';
  mUF: any = '';
  mCidade: any = '';
  urlECfoto: any = '';
  avoidP: boolean = true;
  hideCrown: boolean = false;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router,  public tmaService: TamasAlunoService) { }

  ngOnInit() {
    this.hideCL = true;
    if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios' && !this.tmaService.hcPremium){
      this.avoidP = true;
    }
    else{
        this.avoidP = false;
    }

    if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios' ){
      this.hideCrown = true;
    }
    
    this.cidadeAtual = this.route.snapshot.paramMap.get('cidade').replace(/\-/g, ' ');
    if(this.route.snapshot.paramMap.get('cidade') !== ''){
      this.tmaService.shopCidade = this.route.snapshot.paramMap.get('cidade').replace(/\-/g, ' ');
      this.tmaService.shopUF = this.route.snapshot.paramMap.get('uf');

      //talvez pegar o nome da categoria diretamente no servidor
      //retornar um json com nomecategoria e os produtos que compõe ela
      this.categoriaAtual = this.route.snapshot.paramMap.get('qcategoria');
      this.mCidade = this.route.snapshot.paramMap.get('cidade').replace(/\-/g, ' ');
      this.mUF = this.route.snapshot.paramMap.get('uf');

    }

    //enviar req para servidor contendo uf + cidd + cat
    //no servidor trabalhar a tag top
    //db espec wis top
    this.loadProdutos();

  }
  

  loadProdutos() :void{
    this.hideCL = false;
    var dadosIn = 'cidade=' + this.mCidade + '&uf=' + this.mUF + '&urlcat=' + this.categoriaAtual;
    this.tmaService.listaProdCS(dadosIn)
    .subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if(qRes['res'] == 'done'){
        this.listaProdutos = qRes['arrProd'];
        this.nomeCategoria = qRes['nomeCS'];
        this.urlECfoto =  this.tmaService.urlRepositorioS3 + "/ecommerce/products/";
      }
    })

    // this.listaProdutos.push({ id:1, nome: "100% WHEY GOLD STANDARD", preco: 159.5, precoPremium: 139.9, imagem: 'whey-on-2lb.jpg' })
    // this.listaProdutos.push({ id: 2, nome: "ISOPURE ZERO CARB", preco: 309.5, precoPremium: 245.9, imagem: 'whey-isopure.jpg' })
    // this.listaProdutos.push({ nome: "ISOPURE ZERO CARB", preco: 309.5, precoPremium: 245.9, imagem: 'whey-isopure.jpg' })
    // this.listaProdutos.push({ nome: "ISOPURE ZERO CARB", preco: 309.5, precoPremium: 245.9, imagem: 'whey-isopure.jpg' })
    // this.listaProdutos.push({ nome: "ISOPURE ZERO CARB", preco: 309.5, precoPremium: 245.9, imagem: 'whey-isopure.jpg' })
    // this.listaProdutos.push({ nome: "100% WHEY GOLD STANDARD", preco: 159.5, precoPremium: 139.9, imagem: 'whey-on-2lb.jpg' })
    // this.listaProdutos.push({ nome: "100% WHEY GOLD STANDARD", preco: 159.5, precoPremium: 139.9, imagem: 'whey-on-2lb.jpg' })
  }
  goDetail(idProduto: any, urlCategoria: any):void{
    this.tmaService.shopUrlAnterior = '/shopping/' +  this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-') + '/'  + this.categoriaAtual;
    this.router.navigate(['/shopping/' +  this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-') + '/' + urlCategoria + '/produto/' + idProduto]);
    //this.router.navigate(['/shopping/' +  this.tmaService.shopUF + '/' + this.tmaService.shopCidade + '/' + this.categoriaAtual + '/produto/' + idProduto]);
    //this.router.navigate(['/shopping/produto/' + idProduto]);
  }

  trocarCidade() :void{
    this.router.navigate(['pre-shop/uf']);
  }
  voltar() :void{
    //this._location.back();
    this.router.navigate(['/shop/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-')]);
  }

}
